import useRouter from "./useRouter";
export default function useNavigate() {
    const [, setRouter] = useRouter();
    return (to) => {
        if (!to.startsWith("http"))
            setRouter.changeLocation(to);
        else
            window.location.href = to;
    };
}
